import API from "../common/API"
import { fetchGet, ErrorCallback } from "../common/Requests"
import { CurrentUser } from "./CurrentUserResource"

type FetchCurrentUserCallback = (user: CurrentUser) => void

export function fetchCurrentUser(handleSuccess: FetchCurrentUserCallback, handleError: ErrorCallback) {
  fetchGet(
    `${API.baseUrl}/user`,
    (json) => handleSuccess(json as CurrentUser),
    handleError
  ) 
}

export { CurrentUser }